import { useLocation, useNavigate } from 'react-router-dom'

import { useAppContext } from '@hooks/useAppContext'

import { ErrorType } from '@storage/interfaces/types'

export const useError = () => {
    const {
        appState,
        setStopLoadingOnError,
        setAdobeAnalytics,
        setError,
        removeError,
    } = useAppContext()
    const { session, configuration } = appState
    const location = useLocation()
    const navigate = useNavigate()

    const evaluateError = (errorCode: number, isLoggedIn: boolean | null) => {
        let errorData:
            | {
                  errorCode?: number
                  navigateUrl?: string
                  errorDesc?: string
                  errorType: ErrorType
              }
            | undefined = {
            errorCode: 560,
            navigateUrl: '/error',
            errorDesc: 'To be defined',
            errorType: 'mo-service-error',
        }

        if (!isLoggedIn) {
            errorData = {
                errorCode,
                navigateUrl: '/error',
                errorType: 'auth-failure',
            }
        }

        if (errorCode >= 400 && errorCode < 500) {
            errorData = {
                errorCode,
                navigateUrl: '/error',
                errorType: 'not-found-404',
            }
        } else if (errorCode >= 500) {
            errorData = {
                errorCode,
                navigateUrl: '/error',
                errorDesc: 'to be defined',
                errorType: 'mo-service-error',
            }
        } else {
            errorData = {
                errorCode,
                navigateUrl: '/error',
                errorDesc: 'to be defined',
                errorType: 'mo-service-error',
            }
        }
        return errorData
    }

    function errorHandler(error: any) {
        // const errorCode = error?.response?.status;
        const { isLoggedIn } = session
        const errorData = evaluateError(error, isLoggedIn)
        // const newPreviousPage = location.pathname.replace(/[^\w\s]/gi, '/');

        if (errorData) {
            setStopLoadingOnError(true)

            setError({
                showError: true,
                errorType: errorData.errorType,
                errorDescription: `${error}` || '',

                onButtonClick: () => {
                    removeError()
                    if (errorData.navigateUrl) {
                        navigate(errorData.navigateUrl)
                    }
                },
            })
        }
    }

    return {
        errorHandler,
    }
}
